<div style="padding: 0px 30px;">
    <h1 style="color: #002b5c; text-transform: none; padding-top: 20px">Daily Report</h1>
    <mat-form-field appearance="fill" [formGroup]="reportForm" required>
        <mat-label>Choose a Date</mat-label>
        <input matInput readonly [matDatepicker]="picker" formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <table *ngIf="reportValues" style="width:100%">
        <tr style="color: black;">
            <th>Totals</th>
            <th>Cash</th>
            <th>Paid online</th>
            <th>Total</th>
        </tr>
        <tr class="report-row">
            <td class="data-cell">Number of orders</td>
            <td>{{reportValues.totalNumberOfOrders.firstCol}}</td>
            <td>{{reportValues.totalNumberOfOrders.secondCol}}</td>
            <td>{{reportValues.totalNumberOfOrders.thirdCol}}</td>
        </tr>
        <tr class="report-row">
            <td class="data-cell">Order value</td>
            <td>£{{reportValues.totalOrderValue.firstCol | number : '1.2-2'}}</td>
            <td>£{{reportValues.totalOrderValue.secondCol | number : '1.2-2'}}</td>
            <td>£{{reportValues.totalOrderValue.thirdCol | number : '1.2-2'}}</td>
        </tr>
        <tr class="report-row">
            <td class="data-cell">Order value excluding delivery fees</td>
            <td>£{{reportValues.totalOrdersExcludingDelivery.firstCol | number : '1.2-2'}}</td>
            <td>£{{reportValues.totalOrdersExcludingDelivery.secondCol | number : '1.2-2'}}</td>
            <td>£{{reportValues.totalOrdersExcludingDelivery.thirdCol | number : '1.2-2'}}</td>
        </tr>
        <tr class="report-row grey-row">
            <td class="data-cell-grey">Collection</td>
        </tr>
        <tr class="report-row">
            <td class="data-cell">Number of collection orders</td>
            <td>{{reportValues.totalCollectionOrdersCount.firstCol}}</td>
            <td>{{reportValues.totalCollectionOrdersCount.secondCol}}</td>
            <td>{{reportValues.totalCollectionOrdersCount.thirdCol}}</td>
        </tr>
        <tr class="report-row">
            <td class="data-cell">Collection order value</td>
            <td>£{{reportValues.totalCollectionOrdersValue.firstCol | number : '1.2-2'}}</td>
            <td>£{{reportValues.totalCollectionOrdersValue.secondCol | number : '1.2-2'}}</td>
            <td>£{{reportValues.totalCollectionOrdersValue.thirdCol | number : '1.2-2'}}</td>
        </tr>
        <tr class="report-row grey-row">
            <td class="data-cell-grey">Delivery</td>
        </tr>
        <tr class="report-row">
            <td class="data-cell">Number of delivery orders</td>
            <td >{{reportValues.totalDeliveryOrdersCount.firstCol}}</td>
            <td>{{reportValues.totalDeliveryOrdersCount.secondCol}}</td>
            <td>{{reportValues.totalDeliveryOrdersCount.thirdCol}}</td>
        </tr>
        <tr class="report-row">
            <td class="data-cell">Delivery order value</td>
            <td>£{{reportValues.totalDeliveryOrdersValue.firstCol | number : '1.2-2'}}</td>
            <td>£{{reportValues.totalDeliveryOrdersValue.secondCol | number : '1.2-2'}}</td>
            <td>£{{reportValues.totalDeliveryOrdersValue.thirdCol | number : '1.2-2'}}</td>
        </tr>
    </table>
</div>